package com.iregained.site.components.sections.clinicians.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px

val ImplementationContainerStyle = CssStyle.base {
    Modifier.fillMaxWidth().backgroundColor(colorMode.toSitePalette().custom.lightGray) // Alternating rhythm
}

val ImplementationGridStyle = CssStyle.base {
    Modifier.fillMaxWidth().maxWidth(1440.px).gap(40.px)
}

val ImplementationCardStyle = CssStyle {
    base {
        Modifier.fillMaxWidth().minHeight(350.px).backgroundColor(Colors.White).borderRadius(16.px).padding(32.px)
            .border(1.px, LineStyle.Solid, colorMode.toSitePalette().custom.divider)
            .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
            .boxShadow(0.px, 4.px, 12.px, color = Colors.Black.copy(alpha = 10)).translateY(0.px)
    }
    hover {
        Modifier.boxShadow(0.px, 12.px, 24.px, color = Colors.Black.copy(alpha = 15))
            .translateY((-8).px) // Lifts the card on hover
    }
}

val ImplementationCardIconStyle = CssStyle.base {
    Modifier.size(64.px).margin(bottom = 24.px)
}

val ImplementationCardTitleStyle = CssStyle.base {
    Modifier.fontSize(24.px).fontWeight(FontWeight.SemiBold).color(colorMode.toSitePalette().custom.darkText)
        .margin(bottom = 12.px)
}

val ImplementationCardDescStyle = CssStyle.base {
    Modifier.fontSize(18.px).color(colorMode.toSitePalette().custom.darkText.toRgb())
        .margin(bottom = 24.px).lineHeight(1.5)
}

val ImplementationListContainerStyle = CssStyle.base { Modifier.margin(top = 8.px) }
val ImplementationUlStyle = CssStyle.base { Modifier.padding(left = 20.px).margin(0.px).color(colorMode.toSitePalette().custom.darkText) }
val ImplementationLiStyle = CssStyle.base { Modifier.margin(bottom = 8.px) }

val ImplementationLiTextStyle = CssStyle.base {
    Modifier.fontSize(14.px).color(colorMode.toSitePalette().custom.darkText).lineHeight(1.5)
}